import { ActionCreatorWithPayload } from '@reduxjs/toolkit';
import { useCallback } from 'react';
import { StoryCard, storyCardApi } from '../../../../services';
import { useAppDispatch } from '../../../hooks';
import { ReorderArgs } from '../../SortableList';

interface UseFeedCardReorderArgs {
  cards: StoryCard[];
  updatePosition: ActionCreatorWithPayload<{ dragId: number; targetId: number }>;
}

export const useFeedCardReorder = ({ cards, updatePosition }: UseFeedCardReorderArgs) => {
  const dispatch = useAppDispatch();

  const [storyCardPositionUpdate] = storyCardApi.endpoints.storyCardPositionUpdate.useMutation();

  return useCallback(
    ({ activeId, overId }: ReorderArgs) => {
      const overCard = cards.find(({ id }) => id === overId);

      if (!overCard) {
        return;
      }

      const { storyId, position } = overCard;

      dispatch(updatePosition({ dragId: activeId, targetId: overId }));

      storyCardPositionUpdate({ storyId, storyCardId: activeId, position });
    },
    [cards, dispatch, storyCardPositionUpdate, updatePosition]
  );
};
